module.exports = __webpack_public_path__ + "img/manda_002.59cad59d.png";